<script>
  import { loadCSS } from "../../../../../../Script/loadLibrary"
  import { onMount } from "svelte"
  import defaultFonts from "../../../stores/fileTemplateDefaultFonts"
  import ApplicationState from "../../../../../../Stores/applicationStates"
  import axios from "axios"
  import notify from "../../../../../../Script/notify"

  /**
   * @type {Array} Array of font details
   */
  let fontObjList = []
  /**
   * @type {Boolean} To hide and show the loading screen
   */
  let showLoader
  /**
   * Executes the following code when the component mounts
   */

  let closeNotification = {
    close() {},
  }

  export let tempState = {}

  onMount(async () => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      showLoader = true // Set the loader to be displayed.

      $defaultFonts.fontList = [] // Reset the font list.
      tempState.fonts = [] // Reset the fonts in the file template state.
      const { data } = await axios.get("/api/swagger/v2/fonts", {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }) // Send a GET request to retrieve the fonts.

      if (data.error && !data.success) {
        throw data.errorCode // Throw an error if the response indicates an error.
      }

      fontObjList = [...data.fonts] // Assign the font object list.

      for (let i = 0; i < data.fonts.length; i++) {
        $defaultFonts.fontList = [...$defaultFonts.fontList, data.fonts[i].name] // Add each font name to the default font list.
      }

      $defaultFonts.fontList.sort() // Sort the font list alphabetically.
    } catch (error) {
      closeNotification.close()
      const info = "PAGE: File template editor (Font list)\nEVENT: onMount"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoader = false // Set the loader to be hidden.
    }
  })
  /**
   * Defines a function to add a new font.
   */
  const addFont = async () => {
    $defaultFonts.newFontListModal = false // Close the new font list modal.

    if (tempState.apiFonts.length) {
      // Check if there are any API fonts selected.
      $defaultFonts.selectedFonts = [...tempState.apiFonts, ...$defaultFonts.selectedFonts] // Combine the API fonts with the selected fonts.
      $defaultFonts.selectedFonts = [...new Set($defaultFonts.selectedFonts)] // Remove duplicate fonts.
      $defaultFonts.selectedFonts.sort() // Sort the fonts alphabetically.

      for (let i = 0; i < tempState.apiFonts.length; i++) {
        // Loop through the API fonts.
        for (let j = 0; j < fontObjList.length; j++) {
          // Loop through the font object list.
          if (fontObjList[j].name == tempState.apiFonts[i]) {
            // Check if the font CSS is not already loaded.
            await loadCSS(fontObjList[j].name, fontObjList[j].uri) // Load the font CSS dynamically.
            break
          }
        }
      }
    }

    tempState.notifyFooter = "New font Added" // Set a notification message.
  }
</script>

<div class="fixed inset-0 z-40 flex-col items-center justify-center {showLoader ? 'flex' : 'hidden'}">
  <div class="h-20 w-20 animate-spin rounded-full border-2 border-gray-300 border-r-blue-500" />
  <h1 class="mt-2 text-base font-medium text-white">Fetching Fonts...</h1>
</div>
<div class="fixed inset-0 z-30 flex flex-col items-center justify-center overflow-y-auto bg-[#000000cc] text-left backdrop-blur-md transition-opacity">
  <div class={showLoader ? "blur-sm" : "blur-none"}>
    <div class="w-[400px] rounded-t-md bg-darkgray p-6">
      <div class="flex items-center justify-between pb-3">
        <h1 class="text-lg font-bold tracking-wide text-slate-100">Add Font To List</h1>

        <button
          on:click={() => {
            $defaultFonts.addCustomFont = true
          }}
          class="active:bg-green-g00 group flex h-9 w-2/5 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-yellow-500 px-2 text-sm font-medium text-white hover:bg-yellow-600 focus:outline-none"
        >
          <span class="text-white">
            <i class="fa-solid fa-font" />
          </span>
          <span class="select-none">&nbsp;&nbsp;Request Font</span>
        </button>
      </div>

      <p class="pb-3 text-sm font-normal leading-relaxed text-gray-600">If you have any custom font URL, Paste that custom font link here. Otherwise Import any custom font link and paste it here.</p>
      <div class="flex gap-3">
        <div class="h-60 w-full space-y-2 overflow-y-auto rounded-md border border-stone-700 bg-[#242424] p-3">
          {#each $defaultFonts.fontList as fontname, i}
            <div class="flex items-center gap-3">
              <input id="font{i}" type="checkbox" bind:group={tempState.apiFonts} name="font{i}" value={fontname} class="h-4 w-4" />
              <label for="font{i}" class="flex cursor-pointer select-none items-center gap-3 rounded-md text-sm tracking-wide text-white hover:text-blue-500">
                {fontname}
              </label>
            </div>
          {/each}
        </div>
      </div>
    </div>

    <div class="flex justify-between rounded-b-md bg-[#242424] px-5 py-3">
      <button
        on:click={() => {
          $defaultFonts.newFontListModal = false
        }}
        class="active:bg-green-g00 group flex h-9 w-1/3 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-red-500 px-2 text-sm font-medium text-white hover:bg-red-600 focus:outline-none"
      >
        <span class="text-white">
          <i class="fa-solid fa-circle-xmark" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Close</span>
      </button>

      <button disabled={!tempState.apiFonts.length} on:click={addFont} class="active:bg-green-g00 group flex h-9 w-2/4 cursor-pointer items-center justify-center rounded-md border border-stone-700 bg-green-500 px-2 text-sm font-medium text-white hover:bg-green-600 focus:outline-none disabled:cursor-not-allowed disabled:opacity-30">
        <span class="text-white">
          <i class="fa-solid fa-plus" />
        </span>
        <span class="select-none">&nbsp;&nbsp;Add Font to List</span>
      </button>
    </div>
  </div>
</div>
